import script from "./xtx-tabs.vue?vue&type=script&lang=js"
export * from "./xtx-tabs.vue?vue&type=script&lang=js"

import "./xtx-tabs.vue?vue&type=style&index=0&id=682231f2&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-682231f2"]])

export default __exports__